import { Box } from '@zillow/constellation-10';
import { AvatarGroup, Bone } from '@zg-rentals/satellite-components';
import { conversationNavWrapperStyles } from '.';

export default function ConversationNavSkeleton(): JSX.Element {
  return (
    <Box css={conversationNavWrapperStyles}>
      <AvatarGroup participants={['']} />
      <Bone type="line" css={{ width: '40%', marginLeft: 'default' }} />
    </Box>
  );
}
